<script setup lang="ts">
import { formatNumber } from '@/helpers'
import { watch } from 'vue';
import InputCardComponent from './InputCardComponent.vue';
import { useAgreementStore } from '@/stores/agreement';

const agreementStore = useAgreementStore()

const props = defineProps({
  label: { type: String, required: true },
  unit: { type: String, required: true },
  min: { type: Number, default: 1 },
  max: { type: Number, default: 1000 },
  step: { type: Number, default: 1 },
  useNumberFormat: { type: Boolean, default: true }
})

const model = defineModel<number>()

watch(() => props.max, (value) => {
  if (model.value && value < model.value) {
    model.value = props.max
  }
})
</script>

<template>
  <InputCardComponent :label="label">
    <h1 class="text-center font-weight-bold pt-2 pb-2">
      {{ useNumberFormat ? formatNumber(model ?? 0) : model ?? 0 }} {{ unit }}
    </h1>
    <div class="d-flex align-center justify-space-between px-3">
      <h4>
        {{ useNumberFormat ? formatNumber(min) : min }}
      </h4>
      <h4>
        {{ useNumberFormat ? formatNumber(max) : max }}
      </h4>
    </div>
    <v-slider
      v-model="model"
      :step="step"
      :min="min"
      :max="max"
      show-ticks="always"
      thumb-size="30"
      track-size="10"
      hide-details
      @end="agreementStore.calculate"
    />
  </InputCardComponent>
</template>